export const LANG_COOKIE = 'rra_lang';
export const DEFAULT_LANG = 'tr';

const RTL_CODES = new Set(['ar', 'he', 'fa', 'ur', 'ps', 'ku', 'dv', 'yi']);

export function isRtlLang(code: string): boolean {
  return RTL_CODES.has(code);
}
